// extracted by mini-css-extract-plugin
module.exports = {"hot-live-list":"style_hot-live-list__HvYir","hot-live-list__title":"style_hot-live-list__title__KOd79"};